module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/ja.json
// module id = 562
// module chunks = 0